/**
 * 是否包含汉字
 * @param {*} value
 * @returns
 */
export function hasSinogram(value) {
  const reg = /[\u4E00-\u9FFF]/;
  return reg.test(value);
}

/**
 * 是否是正整数
 * @param {*} value
 * @param {*} callback
 * @returns
 */
export function isInteger(value) {
  const reg = /^[1-9]\d*$/;
  return reg.test(value);
}

// 只包含数字
export const isNumber = (val) => {
  const reg = /^[0-9]+$/;
  return reg.test(val);
};

/**
 * 是否已http、https开头
 * @param {*} value
 * @returns
 */
export function isHttp(value) {
  const reg = /(http|https):\/\/([\w.]+\/?)\S*/;
  return reg.test(value);
}

/**
 * 是否是IP地址
 * @param {*} value
 * @returns
 */
export function isIp(value) {
  const reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
  return reg.test(value);
}

/**
 * 是否是域名
 * @param {*} value
 * @param {*} callback
 */
export function isDomin(value) {
  const reg = /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*$/;
  return reg.test(value);
}

/**
 * 是否是邮箱
 * @param {*} value
 * @returns
 */
export function isEmail(value) {
  const reg = /^[A-Za-z\d0-9]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/;
  return reg.test(value);
}

/**
 * 是否是手机
 * @param {} value
 */
export function isPhone(value) {
  const reg = /^[1]\d{10}$/;
  return reg.test(value);
}

/**
 * 是否是座机
 * @param {*} value
 * @returns
 */
export function isLandline(value) {
  const reg = /^[0][1-9]{2,3}-[0-9]{5,10}$/;
  return reg.test(value);
}

/**
 * 是否包含空格
 * @param {*} value
 * @returns
 */
export function hasSpace(value) {
  const reg = /[^\S\n\r\t]/;
  return reg.test(value);
}

/**
 * 是否由数字字母组成
 * @param {*} value
 */
export function isLetterAndNum(value) {
  const reg = /^[a-zA-Z0-9]+$/;
  return reg.test(value);
}

/**
 * 是否由数字字母一起组成
 * @param {*} value
 */
export function isBothLetterAndNum(value) {
  const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]+$/;
  return reg.test(value);
}

/**
 * 匹配数字，最多2位小数点
 */
export function isFloat(value) {
  const reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/;
  return reg.test(value);
}

/**
 * 只有数字+字母+符号，不含中文
 */
export function isBothNumLetterSymbol(value) {
  const reg = /^[^\u4e00-\u9fa5]{0,}$/;
  return reg.test(value);
}

/**
 * 只能输入汉字、字母、数字
 */
export function isSinogramLetterNum(value) {
  const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+$/;
  return reg.test(value);
}

/**
 * 匹配数字，至多一位小数
 */
export function isOnePoint(value) {
  const reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,1})?$/;
  return reg.test(value);
}

/**
 * 只能输入0或者1
 */
export function isOneOrNo(value) {
  const reg = /^[01]$/;
  return reg.test(value);
}

/**
* 匹配身份证号码
*/
export function isIdcard(value) {
  const reg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
  return reg.test(value);
}

/**
 * 检查是否是图片
 * @param {*} str
 */
export function isImage(str) {
  const reg = /\.(png|jpg|gif|jpeg|webp)$/;
  return reg.test(str.toLowerCase());
}

/**
 * 检查是否是视频
 */
export function isVideo(str) {
  const reg = /\.(mp4|rmvb|flv|mpeg|avi|dat|mov)$/;
  return reg.test(str.toLowerCase());
}

export default {
  isLetterAndNum,
  hasSinogram,
  hasSpace,
  isIp,
  isHttp,
  isPhone,
  isLandline,
  isDomin,
  isInteger,
  isNumber,
  isFloat,
  isEmail,
  isBothLetterAndNum,
  isBothNumLetterSymbol,
  isOnePoint,
  isOneOrNo,
  isIdcard,
  isSinogramLetterNum,
};
